import {Maybe} from '@coolcolduk/typescript-util';
import {UserPermission, type User} from '@cp/model';
import AnalyticsPage from '../pages/analytics/AnalyticsPage';
import CoursePage from '../pages/course/CoursePage';
import CoursePracticePage from '../pages/coursePractice/CoursePracticePage';
import CoursesPage from '../pages/courses/CoursesPage';
import ExercisePage from '../pages/exercise/ExercisePage';
import FlashCardPage from '../pages/flashcard/FlashCardPage';
import SessionPage from '../pages/session/SessionPage';
import SessionCompletePage from '../pages/sessionComplete/SessionCompletePage';
import NewSessionPage from '../pages/sessionNew/NewSessionPage';
import SessionsPage from '../pages/sessions/SessionsPage';
import StudyPage from '../pages/study/StudyPage';
import TodoPage from '../pages/todo/TodoPage';
import {hasAnyUserPermission} from '../utils/hasUserPermission';
import {PrivateRouteProps, RouteType} from './routeType';

export function routeFeatures(user?: Maybe<User>): RouteType<PrivateRouteProps>[] {
  return [
    {
      path: '/exercise',
      component: ExercisePage,
    },
    {
      path: '/',
      component: CoursesPage,
    },
    {
      path: '/course/:examModuleId',
      component: CoursePage,
    },
    {
      path: '/course/:examModuleId/study/:topic',
      component: StudyPage,
    },
    {
      path: '/course/:examModuleId/practice/:sessionId',
      component: CoursePracticePage,
    },
    {
      path: '/analytics',
      component: AnalyticsPage,
    },
    {
      path: '/flashcards',
      component: FlashCardPage,
    },
    {
      path: '/sessions',
      component: SessionsPage,
    },
    {
      path: '/session/new',
      component: NewSessionPage,
    },
    {
      path: '/session/:sessionId',
      component: SessionPage,
    },
    {
      path: '/session/:sessionId/complete',
      component: SessionCompletePage,
    },
    ...(hasAnyUserPermission(user, [UserPermission.VIP, UserPermission.ADMIN])
      ? [
          {
            path: '/todo',
            component: TodoPage,
          },
        ]
      : []),
  ];
}
